import { render, staticRenderFns } from "./IndustryFrontierMechanism.vue?vue&type=template&id=1879e3ca"
import script from "./IndustryFrontierMechanism.vue?vue&type=script&lang=js"
export * from "./IndustryFrontierMechanism.vue?vue&type=script&lang=js"
import style0 from "./IndustryFrontierMechanism.vue?vue&type=style&index=0&id=1879e3ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports